module.exports = __webpack_public_path__ + "media/images/icon_search_white-2674b129c4e8cb76a9929aaf0e99dc99.svg";